module.exports = __webpack_public_path__ + "static/media/community-partners-first.2f98a754.jpg";